import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import { RelayLoad, relayLoadSchema } from '@sophocles/entities/RelayLoad/relayLoadRecord';
import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_RELAYLOADS = 'RECEIVE_RELAYLOADS';
export function receiveRelayLoads(json) {
  return {
    type: RECEIVE_RELAYLOADS,
    relayLoads: mapListToRecords(json, RelayLoad),
  };
}

/* Request Actions */
export const REQUEST_SITE_GROUP_RELAYLOADS = 'REQUEST_SITE_GROUP_RELAYLOADS';

// unused
export const REQUEST_SITE_RELAYLOADS = 'REQUEST_SITE_RELAYLOADS';
function requestSiteRelayLoads(site_id) {
  return {
    type: REQUEST_SITE_RELAYLOADS,
    site_id,
  };
}

/* Fetch Actions */
export function fetchRelayLoadsForSite(site_id) {
  return dispatch => {
    dispatch(requestSiteRelayLoads(site_id));
    return apiClient
      .get(`/sites/${site_id}/loads/`)
      .then(response => normalizeList(response.data.results, 'relayLoads', relayLoadSchema))
      .then(json => dispatch(receiveRelayLoads(json.entities.relayLoads)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SITE_RELAYLOADS)));
  };
}

/* Edit Actions */
export const EDIT_RELAY_LOAD = 'EDIT_RELAY_LOAD';
export function editRelayLoad(relayLoad_id) {
  return {
    type: EDIT_RELAY_LOAD,
    relayLoad: relayLoad_id,
  };
}

export function patchRelayLoad(relayLoad_id, values, relayLoadTermSingular) {
  const load = relayLoadTermSingular;
  return dispatch => {
    dispatch(editRelayLoad(relayLoad_id));
    return apiClient
      .patch(`/relayloads/${relayLoad_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, relayLoadSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: load + ' Updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveRelayLoads(json.entities.relayLoads));
      })
      .catch(error => dispatch(genericErrorAction(error, EDIT_RELAY_LOAD)));
  };
}

/* Create Actions */
export const CREATE_RELAY_LOAD = 'CREATE_RELAY_LOAD';
function sayCreateRelayLoad(values) {
  return {
    type: CREATE_RELAY_LOAD,
    values: values,
  };
}

export function createRelayLoad(values, relayLoadTermSingular) {
  const load = relayLoadTermSingular;
  return dispatch => {
    dispatch(sayCreateRelayLoad(values));
    return apiClient
      .post(`/relayloads/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, relayLoadSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: load + ' Created',
            level: 'success',
            dismissible: true,
          }),
        );
        dispatch(receiveRelayLoads(json.entities.relayLoads));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, CREATE_RELAY_LOAD));
      });
  };
}

/* Delete Actions */
export const DELETE_RELAY_LOAD = 'DELETE_RELAY_LOAD';
export function sayDeleteRelayLoad(relayLoad_id) {
  return {
    type: DELETE_RELAY_LOAD,
    relayLoad: relayLoad_id,
  };
}

export function deleteRelayLoad(relayLoad_id, relayLoadTermSingular) {
  const load = relayLoadTermSingular;
  return dispatch =>
    apiClient
      .delete(`/relayloads/${relayLoad_id}/`)
      .then(checkHttpStatus)
      .then(r => {
        dispatch(
          addToast({
            title: 'Success',
            message: load + ' Deleted',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(sayDeleteRelayLoad(relayLoad_id));
      })
      .catch(error => {
        console.log('caught error in relayLoadActions', error);
        dispatch(genericErrorAction(error, DELETE_RELAY_LOAD));
      });
}

const receiver = (dispatch, json) => dispatch(receiveRelayLoads(json.entities.relayLoads));

export const handleRelayLoadSocketActions = websocketsHandlerFactory(receiver, sayDeleteRelayLoad, relayLoadSchema);
